/**
 * Email action configuration type and validation
 */

export type EmailActionConfigType = {
  to: string;
  subject: string;
  body: string;
  bodyType?: 'text' | 'html';
  cc?: string;
  bcc?: string;
  replyTo?: string;
  continueOnFail?: boolean;
};

export const defaultEmailConfig: EmailActionConfigType = {
  to: '',
  subject: '',
  body: '',
  bodyType: 'text',
  continueOnFail: false,
};

export const validateEmailConfig = (
  config: EmailActionConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.to || config.to.trim() === '') {
    errors.to = 'Recipient is required';
  }

  if (!config.subject || config.subject.trim() === '') {
    errors.subject = 'Subject is required';
  }

  if (!config.body || config.body.trim() === '') {
    errors.body = 'Body is required';
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getEmailPreviewText = (config: EmailActionConfigType): string =>
  config.to || 'Configure recipient';
